module.exports = __webpack_public_path__ + "static/media/ne.a2b8cf97.mp3";